import { render, staticRenderFns } from "./CalendarView.vue?vue&type=template&id=374175a6&scoped=true&"
import script from "./CalendarView.vue?vue&type=script&lang=js&"
export * from "./CalendarView.vue?vue&type=script&lang=js&"
import style0 from "./CalendarView.vue?vue&type=style&index=0&lang=css&"
import style1 from "./CalendarView.vue?vue&type=style&index=1&id=374175a6&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "374175a6",
  null
  
)

export default component.exports
import {QSpinnerGears,QSelect,QIcon,QTooltip,QBtnGroup,QBtn,QTabs,QTab,QSplitter,QDialog,QField} from 'quasar'
component.options.components = Object.assign({QSpinnerGears,QSelect,QIcon,QTooltip,QBtnGroup,QBtn,QTabs,QTab,QSplitter,QDialog,QField}, component.options.components || {})
